import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPageInfo, defaultPaging } from '@/common/constants/ConstCode';

const state = {
  condition: {
    userNo: '',
    searchFlag: false,
    searchText: '',
    ...defaultPaging
  },
  announcementCondition: {
    userNo: '',
    ...defaultPaging
  },
  detail: {
    deadName: '',
    deadAge: '',
    startDate: '',
    endDate: '',
    churchJob: '',
    commentList: []
  },
  announcement: {},
  pageInfo: { ...defaultPageInfo },
  announcementPageInfo: { ...defaultPageInfo },
  funerals: [],
  announcementList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
